import React from "react";
import { Card, CardContent, Box, Typography, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";
import { Messages } from "./types";

dayjs.extend(utc);
dayjs.extend(tz);

interface Props {
  message: Messages;
  onEdit?: (message: Messages) => void;
}

const MessageCard: React.FC<Props> = ({ message, onEdit }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 1,
        mb: 1,
        boxShadow: "0px 2px 6px rgba(0,0,0,0.05)",
        "&:hover": { boxShadow: "0px 4px 10px rgba(0,0,0,0.1)" },
        p: 1.5,
      }}>
      <CardContent sx={{ p: 0, pb: "0px !important" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box>
            <Typography fontSize={18} fontWeight={600} textAlign="start">
              {message.messageTemplateName}
            </Typography>
            <Typography fontSize={16} fontWeight={400} textAlign="start">
              {message.headline}
            </Typography>
            <Typography fontSize={14} fontWeight={400} textAlign="start">
              Scheduled time:{" "}
              {message.scheduledTime
                ? dayjs(message.scheduledTime)
                    .tz("America/New_York")
                    .format("YYYY-MM-DD hh:mm:ss A")
                : "—"}
            </Typography>
          </Box>

          <Box display="flex" alignItems="center">
            {onEdit && (
              <IconButton onClick={() => onEdit(message)} aria-label="edit">
                <EditIcon fontSize="medium" />
              </IconButton>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MessageCard;
